// „Passwort vergessen?" + „Passwort zurücksetzen" — DE / FR / IT / EN
export const pwresetTranslations = {
  de: {
    forgot: {
      title: "Passwort zurücksetzen",
      intro: "Bitte geben Sie die E-Mail-Adresse Ihres SocialCheck-Kontos ein.",
      emailLabel: "E-Mail-Adresse",
      emailPlaceholder: "ihre@firma.ch",
      submit: "Passwort zurücksetzen",
      sending: "Wird gesendet…",
      back: "Zurück zur Anmeldung",
      neutral: "Falls ein Konto mit dieser E-Mail-Adresse vorhanden ist, haben wir Ihnen einen Link zum Zurücksetzen des Passworts gesendet.",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      adminHint: "Erhalten Sie keine E-Mail (z. B. weil der E-Mail-Versand noch eingerichtet wird)? Administratoren stellen den Zugang über den sicheren Notfall-Zugang wieder her – ganz ohne E-Mail.",
      adminBtn: "Administrativer Notfall-Zugang",
    },
    reset: {
      title: "Neues Passwort festlegen",
      subtitle: "Vergeben Sie ein neues, sicheres Passwort für Ihr Konto.",
      checking: "Link wird geprüft…",
      invalid: "Dieser Link ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte fordern Sie einen neuen Link an.",
      newPw: "Neues Passwort",
      repeatPw: "Neues Passwort wiederholen",
      placeholder: "Mindestens 8 Zeichen",
      repeatPlaceholder: "Passwort wiederholen",
      minHint: "Mindestens 8 Zeichen.",
      tooShort: "Das Passwort muss mindestens 8 Zeichen lang sein.",
      mismatch: "Die beiden Passwörter stimmen nicht überein.",
      save: "Neues Passwort speichern",
      saving: "Wird gespeichert…",
      successTitle: "Passwort geändert",
      success: "Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt anmelden.",
      toLogin: "Zur Anmeldung",
      requestNew: "Neuen Link anfordern",
      error: "Das Zurücksetzen ist fehlgeschlagen. Bitte erneut versuchen.",
    },
  },
  fr: {
    forgot: {
      title: "Réinitialiser le mot de passe",
      intro: "Veuillez saisir l'adresse e-mail de votre compte SocialCheck.",
      emailLabel: "Adresse e-mail",
      emailPlaceholder: "votre@entreprise.ch",
      submit: "Réinitialiser le mot de passe",
      sending: "Envoi…",
      back: "Retour à la connexion",
      neutral: "Si un compte existe avec cette adresse e-mail, nous vous avons envoyé un lien pour réinitialiser votre mot de passe.",
      invalidEmail: "Veuillez saisir une adresse e-mail valide.",
      adminHint: "Vous ne recevez pas d'e-mail (par ex. car l'envoi d'e-mails est en cours de configuration) ? Les administrateurs peuvent restaurer l'accès via l'accès d'urgence sécurisé – sans e-mail.",
      adminBtn: "Accès d'urgence administrateur",
    },
    reset: {
      title: "Définir un nouveau mot de passe",
      subtitle: "Choisissez un nouveau mot de passe sécurisé pour votre compte.",
      checking: "Vérification du lien…",
      invalid: "Ce lien est invalide, expiré ou déjà utilisé. Veuillez demander un nouveau lien.",
      newPw: "Nouveau mot de passe",
      repeatPw: "Confirmer le mot de passe",
      placeholder: "Au moins 8 caractères",
      repeatPlaceholder: "Répéter le mot de passe",
      minHint: "Au moins 8 caractères.",
      tooShort: "Le mot de passe doit comporter au moins 8 caractères.",
      mismatch: "Les deux mots de passe ne correspondent pas.",
      save: "Enregistrer le nouveau mot de passe",
      saving: "Enregistrement…",
      successTitle: "Mot de passe modifié",
      success: "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.",
      toLogin: "Vers la connexion",
      requestNew: "Demander un nouveau lien",
      error: "La réinitialisation a échoué. Veuillez réessayer.",
    },
  },
  it: {
    forgot: {
      title: "Reimposta la password",
      intro: "Inserisci l'indirizzo e-mail del tuo account SocialCheck.",
      emailLabel: "Indirizzo e-mail",
      emailPlaceholder: "tua@azienda.ch",
      submit: "Reimposta la password",
      sending: "Invio in corso…",
      back: "Torna all'accesso",
      neutral: "Se esiste un account con questo indirizzo e-mail, ti abbiamo inviato un link per reimpostare la password.",
      invalidEmail: "Inserisci un indirizzo e-mail valido.",
      adminHint: "Non ricevi e-mail (ad es. perché l'invio è ancora in fase di configurazione)? Gli amministratori possono ripristinare l'accesso tramite l'accesso di emergenza sicuro – senza e-mail.",
      adminBtn: "Accesso di emergenza amministratore",
    },
    reset: {
      title: "Imposta una nuova password",
      subtitle: "Scegli una nuova password sicura per il tuo account.",
      checking: "Verifica del link…",
      invalid: "Questo link non è valido, è scaduto o è già stato utilizzato. Richiedi un nuovo link.",
      newPw: "Nuova password",
      repeatPw: "Ripeti la password",
      placeholder: "Almeno 8 caratteri",
      repeatPlaceholder: "Ripeti la password",
      minHint: "Almeno 8 caratteri.",
      tooShort: "La password deve contenere almeno 8 caratteri.",
      mismatch: "Le due password non corrispondono.",
      save: "Salva la nuova password",
      saving: "Salvataggio…",
      successTitle: "Password modificata",
      success: "La tua password è stata modificata con successo. Ora puoi accedere.",
      toLogin: "Vai all'accesso",
      requestNew: "Richiedi un nuovo link",
      error: "La reimpostazione non è riuscita. Riprova.",
    },
  },
  en: {
    forgot: {
      title: "Reset password",
      intro: "Please enter the email address of your SocialCheck account.",
      emailLabel: "Email address",
      emailPlaceholder: "you@company.ch",
      submit: "Reset password",
      sending: "Sending…",
      back: "Back to sign in",
      neutral: "If an account exists for this email address, we have sent you a link to reset your password.",
      invalidEmail: "Please enter a valid email address.",
      adminHint: "Not receiving an email (e.g. because email sending is still being set up)? Administrators can restore access via the secure emergency access – without email.",
      adminBtn: "Administrative emergency access",
    },
    reset: {
      title: "Set a new password",
      subtitle: "Choose a new, secure password for your account.",
      checking: "Checking link…",
      invalid: "This link is invalid, expired or already used. Please request a new link.",
      newPw: "New password",
      repeatPw: "Repeat new password",
      placeholder: "At least 8 characters",
      repeatPlaceholder: "Repeat password",
      minHint: "At least 8 characters.",
      tooShort: "The password must be at least 8 characters long.",
      mismatch: "The two passwords do not match.",
      save: "Save new password",
      saving: "Saving…",
      successTitle: "Password changed",
      success: "Your password was changed successfully. You can now sign in.",
      toLogin: "To sign in",
      requestNew: "Request a new link",
      error: "The reset failed. Please try again.",
    },
  },
};
